{
  "pluginMap": {
    "map-bikeracks": {
      "path": "@city-assets/plugins/kerrokantasi-bikeracks",
      "repo": "https://github.com/jvanamo/kerrokantasi-bikeracks"
    },
    "map-winterbiking": {
      "path": "@city-assets/plugins/kerrokantasi-winterbiking",
      "repo": "https://github.com/City-of-Helsinki/kerrokantasi-winterbiking"
    }
  }
}
